<template>
  <div class="learning">
    <div class="second-hr"></div>
    <div class="learning-contents">
      <div class="learning-contents-title">
        <div>{{title}}</div>
      </div>
      <div class="learning-contents-desc">
        <div v-for="text in desc">{{text}}</div>
      </div>
    </div>
    <template v-for="line in parseInt(missions.length / 5)">
      <div class="circle-line">
        <div class="circle-background-bar"></div>
        <div v-for="(mission, mi) in missions.slice((line - 1) * 5, line * 5)"
             :key="mission[0]"
             @click="toMission(mission[0])"
             class="link-circle"
             :class="'circle-' + btnType[mission[1]]">
          <p>{{(line - 1) * 5 + mi + 1}}</p>
        </div>
        <div v-if="isCodingParty" class="medal" @click="showCert(cleared[line - 1], line)">
          <img :src="medal[`${line === 1 ? 'basic' : 'clear'}${cleared[line - 1] ? '' : 'Gray'}`]">
        </div>
      </div>
      <br v-if="missions.length !== line * 5">
    </template>
  </div>
</template>

<script>
    import axios from 'axios'

    export default {
        name: 'mapStageTemplate',
        props: {
          title: String,
          desc: Array,
          isCodingParty: {
            type: Boolean,
            default: () => false
          },
          missions: {
            type: Array,
            default: () => []
          },
          isTrial: {
            type: Boolean,
            default: false
          }
        },
        data() {
          return {
            btnType: ['wait', 'proceeding', 'succeeded'],
            medal: {
              basic: require('../../assets/images/map/medal_basic.png'),
              basicGray: require('../../assets/images/map/medal_basic_gray.png'),
              clear: require('../../assets/images/map/medal_clear.png'),
              clearGray: require('../../assets/images/map/medal_clear_gray.png')
            },
            lbparty: '',
          }
        },
        computed: {
          cleared() {
            const missions = []
            for (let i = 0; i < parseInt(this.missions.length / 5); i++)
              missions[i] = this.missions.slice(i * 5, (i + 1) * 5)
            return missions.map(e => !e.some(e2 => e2[1] !== 2))
          }
        },
        methods: {
          showCert (isClear, line) {
            if (isClear) {
              this.$emit('openCertification', { title: this.title, line, isTrial: false });
            } else {
              this.$emit('showModal', 'map-alert-template', '미션을 완료 해주세요.')
            }
          },
          to(link) {
            //location.href = link
            //window.open(link, '_blank');
            //window.top.location.href = link;
            window.top.open(`${link}?type=${this.isCodingParty ? 'trial' : 'convert'}`, '_blank');
          },
          toMission(cat) {
            const LINK = '/codmos/study/' + cat

            if (this.isCodingParty !== true) {
              this.to(LINK)
              return
            }

            let [cat1, cat2, cat3, cat4] = cat.split('_')
            if (cat4 === '1') {
              this.to(LINK)
              return
            }

            cat4--

            this.lbparty = JSON.parse(this.getCookie( this.getCookie('isLogin') === 'true' ? 'loginUserInfo' : 'dduNonLoginUserInfo') || '{}').lbparty;

            axios.get(
              `${this.API_SERVER_URL}/manage/codmos/record/party/${cat1}/${cat2}/${cat3}/${cat4}?${this.randomId()}`,
              {
                headers: {
                  lbcookie: this.lbparty
                }
              })
              .then(res => {
                if (
                  res.data.code !== '1000'
                  || !Array.isArray(res.data.docs)
                  || !res.data.docs.length
                  || !res.data.docs.some(e => e.isCleared === 1)
                ) throw new Error()
                this.to(LINK)
              })
              .catch(e => {
                this.$emit('showModal', 'map-alert-template', '이전 미션을 완료 해주세요.')
              })
          }
        }
    }
</script>

<style lang="less">
  .medal {
    display: inline-block;
    vertical-align: middle;
    > img {
      z-index: 2;
      position: relative;
      vertical-align: middle;
      cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/map/MapPartialStage.vue